module.exports = __webpack_public_path__ + "media/images/logo-blanco-cuota-facil-b5b2742a1bf8281365f7752d9b983480.png";